import styled from '@emotion/styled';
import { Tooltip } from '@mui/material';
import ErrorIcon from '../../../../utils/icons/ErrorIcon';
import { FormattedMessage } from 'react-intl';

const StyledIcon = styled(ErrorIcon)({
  width: 24,
  height: 20,
});

const FolderLoadErrorIcon = () => (
  <Tooltip
    title={
      <FormattedMessage id="portfolio.challenge.files.add.select.onedrive.file_picker.filesystem.folder.items_load_error" />
    }
  >
    <StyledIcon />
  </Tooltip>
);

export default FolderLoadErrorIcon;
